import { VisuallyHidden } from "react-aria";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogTitle,
} from "@/components/ui/dialog";
import { PricingTable } from "@/shared/components/PricingTable";

export const StripePricingTableDialog = ({
	open,
	onOpenChange,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}) => {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				className="max-w-[90%] max-h-[90vh] overflow-y-auto p-5 pt-10 w-full"
				data-testid="pricing-table-dialog"
			>
				<VisuallyHidden>
					<DialogTitle>Pricing Table</DialogTitle>

					<DialogDescription>
						Choose a plan that fits your needs.
					</DialogDescription>
				</VisuallyHidden>

				<PricingTable />
			</DialogContent>
		</Dialog>
	);
};
